<template>
  <cardTemplate :classCustom="'overall margin-bottom-10'">
    <template #content>
      <div
        class="header flex-row flex__between padding-bottom-10 has-border__bottom"
      >
        <div class="leftSection">
          <div class="tt theTitle theTitle__lv1"></div>
        </div>
        <div class="rightSection flex-row flex__right">
          <div class="tt theTitle">Đã gửi đăng ký</div>
          <div class="tt theTitle" v-if="isTongHopLichTuan">Chưa phê duyệt</div>
          <div class="tt theTitle">Đã ban hành</div>
          <div class="tt theTitle">Huỷ yêu cầu</div>
          <!-- <div class="tt theTitle">Công việc</div> -->
          <!--<div class="tt theTitle">Hành chính</div>-->
        </div>
      </div>
      <div class="body margin-bottom-10">
        <div class="item-info flex-row flex__between has-border__bottom">
          <div class="leftSection">
            <div class="theTitle theTitle__lv1">Lịch tuần</div>
          </div>
          <div class="rightSection flex-row flex__right">
            <div
              class="theTitle txt-center flex-row flex__center clickable"
              @click="viewListChuaDuyet()"
            >
              <span class="number-1 font-size__large font-weight__bold">
                {{
                  (weeklyScheduleDaDangKy &&
                    weeklyScheduleDaDangKy.countLichTuan) ||
                  0
                }}
              </span>
            </div>
            <div
              class="theTitle txt-center flex-row flex__center clickable"
              @click="viewListChuaDuyet()"
              v-if="isTongHopLichTuan"
            >
              <span class="number-1 font-size__large font-weight__bold">
                {{
                  (weeklyScheduleChuaDuyet &&
                    weeklyScheduleChuaDuyet.countLichTuan) ||
                  0
                }}
              </span>
            </div>
            <div
              class="theTitle txt-center flex-row flex__center clickable"
              @click="viewListDaBanHanh()"
            >
              <span class="number-1 font-size__large font-weight__bold">
                {{
                  (weeklyScheduleDaBanHanh &&
                    weeklyScheduleDaBanHanh.countLichTuan) ||
                  0
                }}
              </span>
            </div>
            <div
              class="theTitle txt-center flex-row flex__center clickable"
              @click="viewListHuy()"
            >
              <span class="number-1 font-size__large font-weight__bold">
                {{
                  (weeklyScheduleHuy && weeklyScheduleHuy.countLichTuan) || 0
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </cardTemplate>
</template>


<script>
// import dashBoardService from "../../services/dashBoardService";
// import h from "../../services/h";
// import { EventBus } from "../../event-bus";
import constants from "../../constants";

export default {
  name: "SummaryCardLichTuan",
  components: {
    cardTemplate: () => import("../common/cardTemplate.vue"),
  },
  props: [
    "weeklyScheduleDaBanHanh",
    "weeklyScheduleChuaDuyet",
    "weeklyScheduleDaDangKy",
    "weeklyScheduleHuy",
    "isTongHopLichTuan",
  ],
  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },
  },
  methods: {
    viewListDaBanHanh() {
      this.$store.commit("setCalendarStatusFilter", {
        id: constants.HC_CALENDAR.APPROVE_STATUS.DA_BAN_HANH,
        name: "Đã ban hành",
        level: 3,
      });
      this.$router.push({
        name: "adminstration-regiscalendarweek",
      });
    },

    viewListChuaDuyet() {
      let userDeptRole = this.$store.getters.userDeptRoles.find(
        (item) => item.roleCode === constants.ROLE.CODE.TONG_HOP_LICH_TUAN
      );
      if (userDeptRole && userDeptRole.id) {
        this.$store.commit("changeUserDeptRole", userDeptRole.id);
      }
      this.$store.commit("setCalendarStatusFilter", {
        id: constants.HC_CALENDAR.APPROVE_STATUS.CHUA_PHE_DUYET,
        name: "Chưa phê duyệt",
        level: 1,
      });
      this.$router.push({
        name: "adminstration-regiscalendarweek",
        params: {
          userDeptRoleId:
            userDeptRole && userDeptRole.id
              ? userDeptRole.id
              : this.$store.getters.userDeptRole.id,
        },
      });
    },

    viewListHuy() {
      this.$store.commit("setCalendarStatusFilter", {
        id: constants.HC_CALENDAR.APPROVE_STATUS.HUY_YEU_CAU,
        name: "Hủy yêu cầu",
        level: 1,
      });
      this.$router.push({
        name: "adminstration-regiscalendarweek",
      });
    },

    // viewListMeetingAccepted() {
    //   this.$router.push({
    //     name: "adminstration-index",
    //     query: { state: "dapheduyet_state" },
    //   });
    // },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/SummaryCardLichTuan.vue